// Tunables voor de retentie-engine. Wijzig hier om scores te herijken — geen rebuild nodig.
//
// AI-CONTEXT: See docs/patterns.md#retention-derivation

export const BASELINE_WEEKS = 8;
export const COLD_START_BUSINESS_DAYS = 20; // ~4 werkweken
export const ONBOARDING_GRACE_BUSINESS_DAYS = 14;
export const ONBOARDING_MAX_BUSINESS_DAYS = 60;
export const TRANSITION_MAX_BUSINESS_DAYS = 45;

export const ENGAGEMENT_YELLOW_DROP = 0.4; // 40% onder baseline → geel
export const ENGAGEMENT_RED_DROP = 0.6;    // 60% onder baseline → rood
export const NO_RECENT_ACTIVITY_DAYS = 30; // werkdagen zonder login → rood
export const STALE_LOGIN_DAYS = 10;        // werkdagen zonder login → minstens geel

export const REPORT_WINDOW_MONTHS = 12;
export const MEETCYCLUS_MONTHS = 6;
